import { auth, ensureStorageVersion } from './auth.js';
import { startFriendsBadgePolling } from './lib/friends_badge.js';
import { ensureChatBadgeStarted } from './lib/messaging.js';
import { ensureNotificationsStarted } from './lib/notifications.js';
import { ensurePresenceHeartbeat } from './lib/presence.js';
import {
  ensureSubscriptionSynced,
  isPushSupported,
  permissionState,
  registerServiceWorker,
} from './lib/push.js';
import { startUpdateChecker } from './lib/update_checker.js';
import { initRouter } from './router.js';

// Wipe any stale auth state from previous storage layouts before booting,
// so we never start in the "have JWT but it's invalid" half-state.
ensureStorageVersion();

const root = document.getElementById('app');
initRouter(root);

// Stale-bundle guard — polls /version.txt, prompts a refresh when the
// served value diverges from the build version compiled into this bundle.
startUpdateChecker();

// Friends presence — ping /presence/heartbeat every ~45s while the tab is
// open, so the green dot on the friends list stays warm.
if (auth.isAuthenticated()) {
  ensurePresenceHeartbeat();
  startFriendsBadgePolling();
  void ensureNotificationsStarted();
  ensureChatBadgeStarted();
}
auth.onChange(() => {
  if (auth.isAuthenticated()) {
    ensurePresenceHeartbeat();
    startFriendsBadgePolling();
    void ensureNotificationsStarted();
    ensureChatBadgeStarted();
  }
});

// Best-effort SW registration. Doesn't block render — the SW is push-only
// (no precaching) so the first visit works fine without it. If push is
// supported AND the user has already granted permission (returning user),
// re-sync the subscription with the backend so a Day-1 sub that was
// created in another browser tab or rotated by the push service stays
// in lockstep with /push/subscribe.
if (isPushSupported()) {
  registerServiceWorker().then(() => {
    if (auth.getAccessToken() && permissionState() === 'granted') {
      void ensureSubscriptionSynced();
    }
  });
}
